import React from "react";

import ChartPropertyStatus from "../../components/admin/ChartCarStatus/ChartPropertyStatus";

import ChartUserRole from "../../components/admin/ChartCarStatus/ChartUserRole";

import ChartStatisticsByMonth from "../../components/admin/ChartCarStatus/ChartStatisticsByMonth";

import LoadingSpinner from "../../components/common/LoadingSpinner";

import { useDashboardStats } from "../../hooks/admin/dashboard/useDashboardStats";

const AdminDashboard = () => {
  const {
    loading,

    propertyStatusStats,
    userRoleStats,

    propertiesByMonth,
    usersByMonth,
  } = useDashboardStats();

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="max-w-7xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-8 text-gray-800 dark:text-indigo-400">
        Dashboard Thống Kê
      </h1>

      <div className="flex flex-col lg:flex-row gap-8 mb-8">
        <ChartPropertyStatus
          data={propertyStatusStats}
        />

        <ChartUserRole
          data={userRoleStats}
        />
      </div>

      <ChartStatisticsByMonth
        carsByMonth={propertiesByMonth}
        usersByMonth={usersByMonth}
      />
    </div>
  );
};

export default AdminDashboard;